import * as LDClient from "launchdarkly-js-client-sdk";

export function createLaunchDarklyFactory(params: { apiKey: string }) {
  return {
    client: (context: LDClient.LDContext) =>
      LDClient.initialize(params.apiKey, context),
  };
}
